import React from 'react'
import { Link } from 'react-router-dom';
function Bannersection() {
  return (
    <div>
    <div
  className="hero10"
  style={{
    backgroundImage: "url('assets/img/all-images/bg/hero-bg6.png')",
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  }}
>
  {/* Content here */}


    <div className="container">
        <div className="row">
            <div className="col-lg-8 m-auto">
                <div className="hero10-heading text-center">
                    <h1 data-aos="fade-up" title='Empowering Businesses with Exceptional Talent & HR Solutions' data-aos-duration="1000" className="aos-init aos-animate">Empowering Corporates with Skilled Talent & Strategic Workforce Solutions</h1>
                    <div className="space16 d-lg-none d-block"></div>
                    <div className="heading-pera d-lg-none d-block">
                    <p>"JBY Talent Acquisition & Management Private Limited is a trusted partner for organizations seeking to hire the right talent and build high-performing, future-ready teams."</p>
                    <div className="space24"></div>
                    <div className="btn-area1">
                        <Link to="/Candidate" className="vl-btn10">Find Your Job Now <span><i className="fa-solid fa-arrow-right"></i></span></Link>
                    </div>
                </div>
                </div>
                <div className="space60"></div>
            </div>
        </div>
        <div className="row align-items-center">
            <div className="col-lg-3">
                <div className="others-area aos-init aos-animate" data-aos="fade-right" data-aos-duration="1100">
                    <div className="arrow-btnarea">
                        <Link to="/About">
                            <div className="content">
                              <h6 className="circle rotateme" title='Empowering Businesses with Exceptional Talent & HR Solutions'>
                              <span style={{ transform: 'rotate(0deg)' }}>J</span>
                                <span style={{ transform: 'rotate(17deg)' }}>B</span>
                                <span style={{ transform: 'rotate(34deg)' }}>Y</span>
                                  <span style={{ transform: 'rotate(45deg)' }}>.</span>
                                  <span style={{transform:'rotate(51deg)'}}>T</span>
                             <span style={{ transform: 'rotate(68deg)' }}>A</span>
                                <span style={{ transform: 'rotate(85deg)' }}>L</span>
                                <span style={{ transform: 'rotate(102deg)' }}>E</span>
                                <span style={{ transform: 'rotate(119deg)' }}>N</span>
                                <span style={{ transform: 'rotate(136deg)' }}>T</span>
                               <span style={{ transform: 'rotate(145deg)' }}>.</span>
                                <span style={{ transform: 'rotate(154deg)' }}>A</span>
                                <span style={{ transform: 'rotate(170deg)' }}>C</span>
                                <span style={{ transform: 'rotate(187deg)' }}>Q</span>
                                <span style={{ transform: 'rotate(204deg)' }}>U</span>
                                <span style={{ transform: 'rotate(221deg)' }}>I</span>
                                <span style={{ transform: 'rotate(238deg)' }}>S</span>
                                <span style={{ transform: 'rotate(255deg)' }}>T</span>
                                <span style={{ transform: 'rotate(272deg)' }}>I</span>
                                <span style={{ transform: 'rotate(289deg)' }}>O</span>
                                <span style={{ transform: 'rotate(306deg)' }}>N</span>
                                <span style={{ transform: 'rotate(323deg)' }}>S</span>
                               
                                </h6>
                            </div>
                            <img src="assets/img/icons/arrow1.svg" alt="" className="arrow1"/>
                        </Link>
                    </div>
                    <div className="space90 d-lg-block d-none"></div>
                    <div className="space30 d-lg-none d-block"></div>
                    <div className="img1">
                        <img src="assets/img/elements/home306X368.png" alt="Corporate training and HR consultancy services
"/>
                    </div>
                </div>
            </div>
            <div className="col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
                <div className="images">
                    <img src="assets/img/elements/Aero_left.png" alt="Corporate training and HR consultancy services
" className="elements23"/>
                    <img src="assets/img/elements/Aero_right.png" alt="Corporate training and HR consultancy services
" className="elements24"/>
                    <div className="img1">
                        <img src="assets/img/all-images/hero/hero-img10.png" alt="Corporate training and HR consultancy services
"/>
                    </div>
                </div>
            </div>
            <div className="col-lg-3 aos-init aos-animate" data-aos="fade-left" data-aos-duration="1000">
                <div className="heading-pera d-lg-block d-none">
                    <p>"JBY Talent Acquisition & Management Private Limited is a trusted partner for organizations seeking to hire the right talent and build high-performing, future-ready teams."</p>
                    <div className="space24"></div>
                    <div className="btn-area1">
                        <Link to="/Candidate" className="vl-btn10">Find Your Job Now <span><i className="fa-solid fa-arrow-right"></i></span></Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    </div>
  )
}

export default Bannersection;
